import { computed } from "vue";
import { useUserStore } from "@/stores/useUserStore";

export function useAccountPolicy() {
  const userStore = useUserStore();

  const isAuthReady = computed(() => userStore.isAuthReady);
  const isLoggedIn = computed(() => userStore.isUserLoggedIn);

  const managementTokens = computed(() => userStore.managementTokens);
  const managementTokensCount = computed(() => userStore.managementTokensCount);

  const canCreateAnotherSharedWheel = computed(
    () => userStore.canCreateAnotherSharedWheel
  );

  const ensurePolicyFresh = async () => {
    await userStore.ensurePolicyFresh();
  };

  return {
    isAuthReady,
    isLoggedIn,
    managementTokens,
    managementTokensCount,
    canCreateAnotherSharedWheel,
    ensurePolicyFresh,
  };
}

export default useAccountPolicy;
